<template>
  <div v-if="productLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
  <div v-if="productError" class="mc-error">{{ productError }}</div>
  <div v-if="productLoaded" class="cr-detail">
    <div class="cr-container">
      <div class="cr-detail__card cr-detail-card">
        <div class="cr-detail-card__title">
         {{product.name}}
        </div>
        <div class="cr-detail-card__body">
          <div v-if="product.picture" class="cr-detail-card__left">
            <picture class="cr-detail-card__picture">
              <img class="cr-detail-card__image" :src="product.picture" width="158" height="190" alt="">
            </picture>
          </div>
          <div class="cr-detail-card__right">
            <ul class="cr-detail-card__labels cr-labels">
              <li v-if="product.is_hit" class="cr-labels__item cr-labels__item--green">
                ХИТ
              </li>
              <li v-if="product.is_new" class="cr-labels__item cr-labels__item--blue">
                NEW
              </li>
              <li v-if="product.is_sale" class="cr-labels__item cr-labels__item--red">
                SALE
              </li>
            </ul>
            <div v-if="product.articul" class="cr-detail-card__code">
              Арт. {{ product.articul }}
            </div>
            <div v-if="product.brand && product.brand?.name" class="cr-detail-card__brand cr-brand cr-brand--block">
                                <span v-if="product.brand.image" class="cr-brand__logo">
                                    <img class="cr-brand__logo-image" :src="product.brand.image" width="30" height="30" alt="">
                                </span>
              <span class="cr-brand__name">
                                    {{product.brand.name}}
                                </span>
            </div>
            <div v-if="product.style" class="cr-detail-card__description">
              {{ product.style }}
            </div>
            <div v-if="product.tip_tary || product.measure" class="cr-detail-card__package">
                                <span v-if="product.tip_tary" class="cr-detail-card__package-name">
                                  {{ product.tip_tary }} {{ product.obem_tary }}
                                </span>
              <span v-if="product.measure" class="cr-detail-card__package-size">
                                    {{ product.measure }}
                                </span>
            </div>
            <dl class="cr-detail-card__characteristics-list">
              <div v-if="product.abv" class="cr-detail-card__characteristics-item">
                <dd class="cr-detail-card__characteristics-value">
                  {{ product.abv }}
                </dd>
                <dt class="cr-detail-card__characteristics-term">
                  ABV
                </dt>
              </div>
              <div v-if="product.og" class="cr-detail-card__characteristics-item">
                <dd class="cr-detail-card__characteristics-value">
                  {{ product.og }}
                </dd>
                <dt class="cr-detail-card__characteristics-term">
                  OG
                </dt>
              </div>
              <div v-if="product.ibu" class="cr-detail-card__characteristics-item">
                <dd class="cr-detail-card__characteristics-value">
                  {{ product.ibu }}
                </dd>
                <dt class="cr-detail-card__characteristics-term">
                  IBU
                </dt>
              </div>
            </dl>
            <div class="cr-detail-card__quantity cr-quantity">
              <span class="cr-quantity__value cr-quantity__value--low"></span>
            </div>
          </div>
        </div>
        <div class="cr-detail-card__bottom">
          <div class="cr-detail-card__price">
                            <span class="cr-detail-card__price-current">
                                {{ formatPrice(product.price) }} ₽ / {{ product.unit }}
                            </span>
            <span v-if="product.price_old > product.price" class="cr-detail-card__price-old">
                                {{ product.price_old }} ₽ / {{ product.unit }}
                            </span>
          </div>
          <div v-if="product.priceAll" class="cr-detail-card__price">
                            <span class="cr-detail-card__price-current">
                                {{ product.priceAll }} ₽ / {{ product.unitAll }}
                            </span>
          </div>
          <DetailBasketButton :product="product" :isSticky="isSticky"></DetailBasketButton>
        </div>
      </div>
      <div class="cr-detail__section">
        <div class="cr-detail__section-title">
          Описание
        </div>
        <div class="cr-detail__section-body">
          <p v-html="product.description"></p>
          <div v-if="product.egais" class="cr-detail__info">
            <div class="cr-detail__info-title">
              Наим. ЕГАИС
            </div>
            <div class="cr-detail__info-text">
              {{ product.egais }}
            </div>
          </div>
        </div>
      </div>
      <div class="cr-detail__section">
        <div class="cr-detail__section-title">
          Характеристики
        </div>
        <div class="cr-detail__section-body">
          <dl class="cr-detail__characteristics-list">
            <div v-if="product.style" class="cr-detail__characteristics-item">
              <dt class="cr-detail__characteristics-term">
                                    <span class="cr-detail__characteristics-text">
                                        Стиль
                                    </span>
              </dt>
              <dd class="cr-detail__characteristics-value">
                                    <span class="cr-detail__characteristics-text">
                                        {{ product.style }}
                                    </span>
              </dd>
            </div>
            <div v-if="product.brand" class="cr-detail__characteristics-item">
              <dt class="cr-detail__characteristics-term">
                                    <span class="cr-detail__characteristics-text">
                                        Производитель
                                    </span>
              </dt>
              <dd class="cr-detail__characteristics-value">
                                    <span class="cr-detail__characteristics-text">
                                        {{ product.brand.name }}
                                    </span>
              </dd>
            </div>
            <div v-if="false && product.unit" class="cr-detail__characteristics-item">
              <dt class="cr-detail__characteristics-term">
                                    <span class="cr-detail__characteristics-text">
                                        Единица измерения
                                    </span>
              </dt>
              <dd class="cr-detail__characteristics-value">
                                    <span class="cr-detail__characteristics-text">
                                       {{ product.unit }}
                                    </span>
              </dd>
            </div>
            <div v-if="product.volume" class="cr-detail__characteristics-item">
              <dt class="cr-detail__characteristics-term">
                                    <span class="cr-detail__characteristics-text">
                                        Объем
                                    </span>
              </dt>
              <dd class="cr-detail__characteristics-value">
                                    <span class="cr-detail__characteristics-text">
                                       {{ product.volume }}
                                    </span>
              </dd>
            </div>
            <div v-if="product.tara" class="cr-detail__characteristics-item">
              <dt class="cr-detail__characteristics-term">
                                    <span class="cr-detail__characteristics-text">
                                        Тара
                                    </span>
              </dt>
              <dd class="cr-detail__characteristics-value">
                                    <span class="cr-detail__characteristics-text">
                                        {{ product.tara }}
                                    </span>
              </dd>
            </div>
            <div v-if="product.egais" class="cr-detail__characteristics-item">
              <dt class="cr-detail__characteristics-term">
                                    <span class="cr-detail__characteristics-text">
                                        Код ЕГАИС
                                    </span>
              </dt>
              <dd class="cr-detail__characteristics-value">
                                    <span class="cr-detail__characteristics-text">
                                        {{ product.egais }}
                                    </span>
              </dd>
            </div>
            <div v-if="product.srok" class="cr-detail__characteristics-item">
              <dt class="cr-detail__characteristics-term">
                                    <span class="cr-detail__characteristics-text">
                                        Срок годности, дней
                                    </span>
              </dt>
              <dd class="cr-detail__characteristics-value">
                                    <span class="cr-detail__characteristics-text">
                                        {{ product.srok }}
                                    </span>
              </dd>
            </div>


            <div v-if="product.krepost" class="cr-detail__characteristics-item">
              <dt class="cr-detail__characteristics-term">
                                    <span class="cr-detail__characteristics-text">
                                        Крепость
                                    </span>
              </dt>
              <dd class="cr-detail__characteristics-value">
                                    <span class="cr-detail__characteristics-text">
                                        {{ product.krepost }}
                                    </span>
              </dd>
            </div>

            <div v-if="product.fitting" class="cr-detail__characteristics-item">
              <dt class="cr-detail__characteristics-term">
                                    <span class="cr-detail__characteristics-text">
                                       Фиттинг
                                    </span>
              </dt>
              <dd class="cr-detail__characteristics-value">
                                    <span class="cr-detail__characteristics-text">
                                        {{ product.fitting }}
                                    </span>
              </dd>
            </div>

            <div v-if="product.plotnost" class="cr-detail__characteristics-item">
              <dt class="cr-detail__characteristics-term">
                                    <span class="cr-detail__characteristics-text">
                                        Плотность
                                    </span>
              </dt>
              <dd class="cr-detail__characteristics-value">
                                    <span class="cr-detail__characteristics-text">
                                        {{ product.plotnost }}
                                    </span>
              </dd>
            </div>

            <div v-if="product.gorech" class="cr-detail__characteristics-item">
              <dt class="cr-detail__characteristics-term">
                                    <span class="cr-detail__characteristics-text">
                                        Горечь
                                    </span>
              </dt>
              <dd class="cr-detail__characteristics-value">
                                    <span class="cr-detail__characteristics-text">
                                        {{ product.gorech }}
                                    </span>
              </dd>
            </div>


          </dl>
        </div>
      </div>

      <DetailProductSlider :id="product.id" ></DetailProductSlider>

    </div>
  </div>


  <div v-if="productLoaded" class="cr-page__bottom-sticky sticky-bottom" :class="{ 'is-sticky': isSticky }">
    <div class="cr-container">
      <DetailBasketButton :product="product" :isSticky="isSticky"></DetailBasketButton>
    </div>
  </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ProductItem from './components/ProductItem.vue'
import num from '../mixin/num';
import httpBuildQuery  from "http-build-query";
import queryString from 'query-string';
import {debounce} from "lodash";
import product from "@/mixin/product.vue";
import DetailBasketButton from "@/views/components/DetailBasketButton.vue";
import DetailProductSlider from "@/views/components/DetailProductSlider.vue";

export default {
  data: () => ({
    isSticky: false,
    observer: null

  }),
  mixins: [product],
  created() {
    this.load();
  },
  watch: {
    '$route'() {
      this.load();
    },
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },

  computed: {
    ...mapGetters('detail', [
      'product',
      'productLoading',
      'productError',
      'productLoaded',
    ]),
    ...mapGetters('detail', ['localQuantity']),
  },
  methods: {
    ...mapActions('detail', [
      'fetchDetail'
    ]),
    async load() {
      await this.fetchDetail(this.$route.params.id);
      if (!this.product || typeof this.product !== 'object' || !this.product.id) {
        this.$router.push('/404/');
      }

      this.$nextTick(() => {
        const targetElement = document.querySelector('.cr-detail-card__bottom .cr-detail-card__action');

        this.observer = new IntersectionObserver(
            ([entry]) => {
              console.log('Observer callback:', entry.isIntersecting);
              this.isSticky = !entry.isIntersecting;
            },
            {
              root: null,
              rootMargin: '0px',
              threshold: 0.1
            }
        );

        if (targetElement) {
          console.log('Starting observation of:', targetElement);
          this.observer.observe(targetElement);
        } else {
          console.log('Target element not found');
        }
      });
    }
  },
  components: {
    DetailProductSlider,
    DetailBasketButton
  }
}
</script>
